import {
  DevicePermission,
  DevicePermissionState,
  DeviceStatus,
  GpsStatus,
  UserDevicePermission_Read_Nested,
} from '@treadinc/horizon-api-spec';

class UserDevicePermissionReadNested {
  public static parse(
    proto: UserDevicePermission_Read_Nested,
  ): UserDevicePermissionReadNested {
    return new UserDevicePermissionReadNested(
      proto.device_permission,
      proto.device_permission_state,
    );
  }

  constructor(
    private readonly _devicePermission: DevicePermission,
    private readonly _devicePermissionState: DevicePermissionState,
  ) {}

  public get devicePermission(): DevicePermission {
    return this._devicePermission;
  }

  public get devicePermissionState(): DevicePermissionState {
    return this._devicePermissionState;
  }
}

export class DeviceStatusRead {
  public static parse(proto: DeviceStatus): DeviceStatusRead {
    return new DeviceStatusRead(
      proto.gps_status,
      (proto.user_device_permissions ?? []).map(UserDevicePermissionReadNested.parse),
    );
  }

  constructor(
    private readonly _gpsStatus: GpsStatus,
    private readonly _userDevicePermissions: UserDevicePermissionReadNested[],
  ) {}

  public get gpsStatus(): GpsStatus {
    return this._gpsStatus;
  }

  public get userDevicePermissions(): UserDevicePermissionReadNested[] {
    return this._userDevicePermissions;
  }
}
